<template>
  <div class="fleet-task-section">
    <p class="fleet-task-section__title">
      {{ title }}
    </p>
    <div class="fleet-task-section__card">
      <b-row class="g-2">
        <template v-for="item in infoFOItemsFiltered">
          <b-col
            v-if="item.key == 'status.name'"
            :key="item.key"
            :cols="6"
            class="fleet-task-section__info-title"
          >
            <p class="fleet-task-section__info-title">
              {{ item.label }}
            </p>
            <div
              class="fleet-task-section__info-status"
              :style="getStatusStyle(get(fleetTask, item.key))"
            >
              {{ statusFOItems[get(fleetTask, item.key)]?.label }}
            </div>
          </b-col>

          <b-col v-else-if="item.key === 'vehicle.license_plate'">
            <p class="fleet-task-section__info-title">
              {{ item.label }}
            </p>
            <p class="fleet-task-section__info-value">
              {{ getValue(fleetTask, item.key) }}
              <McBadge
                v-if="getValue(fleetTask, 'vehicle.hull_no')"
                :text="getValue(fleetTask, 'vehicle.hull_no')"
                variant="outlinePlainSecondary"
                size="medium"
                type="button"
              />
            </p>
          </b-col>

          <b-col v-else :key="item.key" :cols="6">
            <p class="fleet-task-section__info-title">
              {{ item.label }}
            </p>
            <p class="fleet-task-section__info-value">
              {{ getValue(fleetTask, item.key) }}
            </p>
          </b-col>
        </template>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import McBadge from '@/components/McBadge'

import get from 'lodash/get'
import { getInfoFOItems } from '../lib/fields/info-items.js'
import { getStatusFOItems } from '../lib/constants/status-items.js'

export default {
  components: {
    McBadge,
  },
  props: {
    title: {
      type: String,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    fleetTask: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      getFeatureFlagValue: 'identity/getFeatureFlagValue',
    }),
    statusFOItems() {
      return getStatusFOItems(this.$t.bind(this))
    },
    infoFOItemsFiltered() {
      return getInfoFOItems(this.$t.bind(this)).filter((item) => item?.isShow !== false)
    },
  },
  methods: {
    get,
    getValue(obj, key) {
      const value = get(obj, key)

      if (key === 'vehicle.hull_no') {
        return value ? value : null
      }

      return value != null && value !== '' ? value : '-'
    },
    getStatusStyle(status) {
      return {
        color: this.statusFOItems[status]?.color,
        backgroundColor: this.statusFOItems[status]?.backgroundColor,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.fleet-task-section {
  &__title {
    font-size: 14px;
  }

  &__card {
    border: 1px solid $mep-color-text-100;
    border-radius: 4px;
    padding: 12px;
  }

  &__info {
    width: fit-content;

    &-title,
    &-value {
      margin-bottom: 4px;
    }

    &-title {
      color: $mep-color-text-300;
    }

    &-value {
      color: $mep-color-text-400;
    }

    &-status {
      width: fit-content;
      border-radius: 4px;
      padding: 4px 8px;
      font-size: 11px;
    }
  }
}
</style>
